import React, { useState } from "react";

import { useAllReservationContext } from "../context/AllReservationContext/AllReservationContext";
import { useToggleAll } from "../../../../lib/hooks/useToggleAll";
import { useAuthContext } from "../../../../lib/context/Auth/AuthContext";

import { WorkspacePicker } from "../../../shared/WorkspacePicker/WorkspacePicker";
import { AllReservationTreeLevel } from "./AllReservationTreeLevel";
import { WayFinderWorkspaceFooterPicker } from "../../../WayFinder/WayFinderPicker/WayFinderWorkspaceFooterPicker";
import { isValidWorkplace } from "../../../Bookings/helpers/isValidWorkspace";
import { tooltips } from "../../../../lib/utils/tooltips";
import { ALL_RESERVATION_LIMIT } from "../../../../lib/utils/constants";
import { ToggleAllButton } from "../../../shared/ToggleAllButton/ToggleAllButton";

export const AllReservationWorkspacePicker = () => {
  const { pickedWorkspaces, setPickedWorkspaces, setOpenWorkspacePicker } =
    useAllReservationContext();
  const [innerWorkspaces, setInnerWorkspaces] = useState(pickedWorkspaces);
  const { allToggled, handleToggleAll } = useToggleAll();
  const { user } = useAuthContext();
  const bookingEnabled = {
    roomBookingEnabled: user?.roomBookingEnabled,
    deskBookingEnabled: user?.deskBookingEnabled,
  };

  const defineDescription = () => {
    if (
      bookingEnabled.roomBookingEnabled &&
      bookingEnabled.deskBookingEnabled
    ) {
      return "Select room and desk calendars below";
    }

    if (bookingEnabled.roomBookingEnabled) {
      return "Select room calendars below";
    }

    return "Select desk calendars below";
  };

  return (
    <WorkspacePicker
      title="Calendar picker"
      description={defineDescription()}
      message={tooltips.bookings.allReservationPicker}
      closePicker={() => setOpenWorkspacePicker(false)}
      footer={
        <WayFinderWorkspaceFooterPicker
          clearWorkspaces={() => {
            if (innerWorkspaces.length > 0) {
              setInnerWorkspaces([]);
            }
          }}
          handleConfirm={() => {
            setPickedWorkspaces(innerWorkspaces);

            setOpenWorkspacePicker(false);
          }}
          desksCounter={0}
          roomsCounter={0}
        >
          <span className="pt-3 d-block text-center WayFinderFormWorkspaces__counter mb-5">
            {innerWorkspaces.length} of max {ALL_RESERVATION_LIMIT} workspace
            calendars selected
          </span>
        </WayFinderWorkspaceFooterPicker>
      }
    >
      {({ rootWorkplaces }) => {
        return (
          <>
            <ToggleAllButton
              allToggled={allToggled}
              onToggleAll={handleToggleAll}
            />

            {rootWorkplaces.map((item) => {
              if (typeof item !== "object") {
                return null;
              }

              return item.map((workplace) => {
                if (!isValidWorkplace(workplace, bookingEnabled)) {
                  return null;
                }

                return (
                  <AllReservationTreeLevel
                    item={workplace}
                    toggleParent={() => {}}
                    key={`${workplace.id}-tree-root`}
                    pickedWorkspaces={pickedWorkspaces}
                    setPickedWorkspaces={setPickedWorkspaces}
                    innerWorkspaces={innerWorkspaces}
                    setInnerWorkspaces={setInnerWorkspaces}
                    allToggled={allToggled}
                  />
                );
              });
            })}
          </>
        );
      }}
    </WorkspacePicker>
  );
};
